import axios from "axios";

/**
 * Wrapper axios untuk Tax Simulator endpoints.
 * Menggunakan REACT_APP_TAX_API_URL (backend port 8000)
 * terpisah dari REACT_APP_API_URL (CMS KNEKS).
 */
export async function apiFetch(endpoint, { method = "GET", body, auth = false } = {}) {
    // Gunakan backend tax simulator jika endpoint dimulai dengan /api/tax-
    const isTaxEndpoint = endpoint.startsWith("/api-tax");
    const baseUrl = isTaxEndpoint
        ? (process.env.REACT_APP_TAX_API_URL || "http://localhost:8000")
        : (process.env.REACT_APP_API_URL || "");

    const url = `${baseUrl}${endpoint}`;

    const headers = {};
    if (auth) {
        const token = localStorage.getItem("accessToken");
        if (token) headers.Authorization = `Bearer ${token}`;
    }

    const response = await axios({
        url,
        method,
        data: body,
        headers: {
            "Content-Type": "application/json",
            ...headers,
        },
    });

    return response.data;
}
